<app-tracking></app-tracking>
<div
  [ngClass]="{
    'modus-layout': isAuthenticated,
  }"
>
  @if (showAuthenticatedHeader) {
    <app-authenticated-header
      [isSidebarOpen]="isSidebarOpen"
      (sidebarOpenEvent)="setIsSidebarOpen($event)"
    ></app-authenticated-header>
  }
  @if (showUnauthenticatedHeader) {
    <app-unauthenticated-header></app-unauthenticated-header>
  }
  <div
    class="modus-body sidebar-closed"
    data-modus-item="body"
    id="modusBody"
    [ngClass]="{
      'sidebar-collapse': !showAuthenticatedHeader,
      'sidebar-open': isSidebarOpen,
      'sidebar-closed': !isSidebarOpen,
    }"
  >
    <nav id="mainSidebar" class="nav flex-column modus-sidebar">
      @if (showAuthenticatedNavigation) {
        <app-authenticated-nav (sidebarOpenEvent)="setIsSidebarOpen($event)"></app-authenticated-nav>
      }
    </nav>
    <router-outlet></router-outlet>
  </div>
  @if (showAuthenticatedFooter) {
    <app-authenticated-footer></app-authenticated-footer>
  }
  @if (showUnauthenticatedFooter) {
    <app-unauthenticated-footer></app-unauthenticated-footer>
  }
</div>
